export default 'https://tme.understood.org/assets/Light_Texture01.e672bf59.jpg'